export default [

    {
        path: "/order",
        name: "order",
        component: () => import("./tab/MyOrder"),
        meta: {
            permiss:['ORDER_TASK_SHOW'],
            title: "工单任务"
        }
    },
    {
        path: "/order/detail/:id",
        name: "orderDetail",
        component: () => import("./components/OrderDetail"),
        meta: {
            permiss:['ORDER_TASK_SHOW'],
            title: "工单详情"
        }
    },
    {
        path: "/order/deal/:id",
        name: "orderDeal",
        component: () => import("./components/OrderDeal"),
        meta: {
            permiss:['ORDER_TASK_HANDLE'],
            title: "工单处理"
        }
    },
]